import { action } from "typesafe-actions";

import { CurrenciesActionTypes } from "./types";

export const selectCurrency = (payload: { currency: string }) => action(CurrenciesActionTypes.SELECT, payload);

export const currencyFetchLocalStorage = () => action(CurrenciesActionTypes.FETCH_LOCAL_STORAGE);
